export const LITE_TARGET_PATH = "/light_user";

export const LITE_GOOGLE_FORM_LINK =
  "https://docs.google.com/forms/d/e/1FAIpQLSdp7TuRhIqwwmUgphnJNe2Lnd3UzwN9dYK4dlqoSGVnlKqf-A/viewform";
